import React from 'react'
import { MONTH_NAMES, DAY_OF_MONTH_OPTIONS } from '../../utils/scheduleRepeat'

const inputClass =
  'w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 text-sm focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400'

const errorInputClass = (hasError) =>
  `${inputClass} ${hasError ? 'border-red-500' : 'border-gray-200 dark:border-border-dark'}`

/**
 * Month → day of month → time picker.
 * @param {boolean} multiMonth - true for monthly (checkboxes), false for once (single select)
 */
const MonthDayTimeFields = ({
  months = [],
  onMonthsChange,
  dayOfMonth,
  onDayOfMonthChange,
  time,
  onTimeChange,
  errors = {},
  multiMonth = true,
  className = '',
}) => {
  const toggleMonth = (monthName) => {
    if (!onMonthsChange) return
    if (months.includes(monthName)) {
      onMonthsChange(months.filter((m) => m !== monthName))
    } else {
      onMonthsChange(
        [...months, monthName].sort(
          (a, b) => MONTH_NAMES.indexOf(a) - MONTH_NAMES.indexOf(b)
        )
      )
    }
  }

  const singleMonth = months[0] || ''

  return (
    <div className={`space-y-4 ${className}`}>
      <div>
        <label className="block text-sm font-medium mb-2 dark:text-white">
          {multiMonth ? '1. Select month(s)' : '1. Select month'}
          <span className="text-red-500">*</span>
        </label>
        {multiMonth ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
            {MONTH_NAMES.map((monthName) => (
              <label
                key={monthName}
                className={`flex items-center gap-2 text-sm font-light px-2 py-1.5 rounded-md border cursor-pointer ${
                  months.includes(monthName)
                    ? 'border-yellowcolor bg-yellowcolor/10 dark:text-white'
                    : 'border-gray-200 dark:border-border-dark dark:text-white'
                }`}
              >
                <input
                  type="checkbox"
                  className="rounded text-yellowcolor focus:ring-yellowcolor"
                  checked={months.includes(monthName)}
                  onChange={() => toggleMonth(monthName)}
                />
                {monthName}
              </label>
            ))}
          </div>
        ) : (
          <select
            className={errorInputClass(errors.months)}
            value={singleMonth}
            onChange={(e) => onMonthsChange(e.target.value ? [e.target.value] : [])}
            name="month"
          >
            <option value="">Select month</option>
            {MONTH_NAMES.map((monthName) => (
              <option key={monthName} value={monthName}>{monthName}</option>
            ))}
          </select>
        )}
        {errors.months && <p className="text-xs text-red-500 mt-1">{errors.months}</p>}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 dark:text-white">
            2. Day of month<span className="text-red-500">*</span>
          </label>
          <select
            className={errorInputClass(errors.dayOfMonth)}
            value={dayOfMonth || ''}
            onChange={(e) =>
              onDayOfMonthChange(e.target.value ? Number(e.target.value) : '')
            }
            name="dayOfMonth"
          >
            <option value="">Select day (1–31)</option>
            {DAY_OF_MONTH_OPTIONS.map((d) => (
              <option key={d} value={d}>{d}</option>
            ))}
          </select>
          {errors.dayOfMonth && (
            <p className="text-xs text-red-500 mt-1">{errors.dayOfMonth}</p>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 dark:text-white">
            3. Time<span className="text-red-500">*</span>
          </label>
          <input
            type="time"
            className={errorInputClass(errors.time)}
            value={time}
            onChange={(e) => onTimeChange(e.target.value)}
            name="time"
          />
          {errors.time && <p className="text-xs text-red-500 mt-1">{errors.time}</p>}
        </div>
      </div>
    </div>
  )
}

export default MonthDayTimeFields
